import { render } from "./advertising-introduce.vue?vue&type=template&id=e296abe4&scoped=true"
const script = {}

import "./advertising-introduce.vue?vue&type=style&index=0&id=e296abe4&scoped=true&lang=less"

import exportComponent from "/Users/xyyw/code/company/web/sanroe-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e296abe4"]])

export default __exports__